import { SystemProps } from '@storyofams/react-ui';
import SbEditable from 'storyblok-react';
import { Video } from '../common/Video';

import { DynamicSectionContainer } from '../dynamic';

type VideoProps = {
  content: {
    url: string;
  };
} & SystemProps;

export const VideoSection = ({ content, ...props }: VideoProps) => {
  return (
    <SbEditable content={content as any}>
      <DynamicSectionContainer
        px={{
          all: 2,
          md: 10,
          lg: 20,
        }}
        {...props}
      >
        <Video url={content?.url} />
      </DynamicSectionContainer>
    </SbEditable>
  );
};
